// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ferroseed: PokeData = {
  "id": 597,
  "name": "ferroseed",
  "height": 6,
  "weight": 188,
  "base_experience": 61,
  "types": [
    PokeType.GRASS,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "pin-missile",
    "harden",
    "self-destruct",
    "explosion",
    "curse",
    "rollout",
    "metal-claw",
    "ingrain",
    "iron-defense",
    "gyro-ball",
    "payback",
    "mirror-shot",
    "flash-cannon",
    "iron-head"
  ],
  "moves": [
    "tackle",
    "pin-missile",
    "curse",
    "metal-claw",
    "razor-leaf",
    "energy-ball",
    "wood-hammer",
    "vine-whip",
    "metal-burst",
    "metal-rush",
    "branch-poke",
    "magnet-bomb",
    "magnet-pull"
  ],
  "evolution_chain": {
    "id": 304,
    "item": null,
    "species": [
      {
        "name": "ferroseed",
        "order": 598,
        "types": [
          PokeType.GRASS,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ferrothorn",
        "order": 599,
        "types": [
          PokeType.GRASS,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 597,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 66.25,
    "speed": 10,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
